import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function BlackBeanBurgers() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Black Bean Burgers</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        1.5 red onions <br></br>
        200g mixed mushrooms<br></br>
        100g rye bread<br></br>
        Ground coriander<br></br>
        400g black beans<br></br>
        Olive oil<br></br>
        40g mature Cheddar cheese<br></br>4 soft rolls<br></br>
        100g ripe cherry tomatoes<br></br>1 lime<br></br>
        Chipotle tabasco sauce<br></br>1 ripe mango<br></br>1 ripe avocado
        <br></br>4 tbsp natural yoghurt<br></br>4 sprigs fresh coriander
        <br></br>
        <br></br>
      </Typography>
      <Typography>
        Preheat the overn to 200C.<br></br>
        Pell 1 onion, plce in a food processor with the musrooms, rye bread, and
        1 teaspoon of ground coriander, and whiz until fine. <br></br>
        Drain and pulse in the black beans, season lightly with sea salt and
        black pepper, then divide into 4 and shape into patties, roughly 2.5cm
        thick.<br></br>
        Rub all over with oil and dust with ground coriander, then place on a
        oiled baking tray and roast for 25 minutes, or until dark and crisy,
        topping with the Cheddar and warming the rolls for the last few minutes.
        <br></br>
        <br></br>
        Meanwhile, peel and very finely chop the reaminaing onion with the
        tomatoes and place in a bowl. <br></br>
        Squeeze over the lime juice, add a few shakes of Tabasco and season to
        taste.<br></br>
        Destone, peel, and finely slice the mango and avocado.<br></br>
        <br></br>
        Halve the warm rolls and divide the yoghurt between the bases, followed
        by half the salsa, the mango, avocado, and coriander leaves. <br></br>
        Top with the burgers, remaining salsa and extra Tabasco, pop the lids on
        and press down lightly.<br></br>
        <br></br>
        Always nice with oven-roasted, skin-on chips.<br></br>
      </Typography>
    </Card>
  );
}
